export const INITIAL_EVENT_BATCH_RECEIVED = "INITIAL_EVENT_BATCH_RECEIVED";
export const EVENT_RECEIVED = "EVENT_RECEIVED";
export const EVENT_REMOVED = "EVENT_REMOVED";
export const EVENT_UPDATED = "EVENT_UPDATED";
export const RECEIVED_EVENT_COMMENT_COUNT = "RECEIVED_EVENT_COMMENT_COUNT";
export const EVENT_TEMPLATE_RECEIVED = "EVENT_TEMPLATE_RECEIVED";
export const EVENT_TEMPLATE_REMOVED = "EVENT_TEMPLATE_REMOVED";
export const EVENT_TEMPLATE_UPDATED = "EVENT_TEMPLATE_UPDATED";
